import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import {Link, useNavigate} from "react-router-dom";
import { getAxiosResponse, putAxiosResponse, postAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { dateConvertToTimeStamp, transformBlankToNull } from '../../services/Util';
import { useSelector, useDispatch } from 'react-redux'
import { updateCustomerBootstrapData } from "../../redux/reducers/CustomerBootstrapDataSlice";
import Constants from "../../Constants";
import jQuery from "jquery";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import $ from 'jquery';
import { handleError } from "../../services/authApiRoutes/APImethods";
import { logError } from "../../services/authApiRoutes/APImethods";

export default function Settings() {
	const scrollRef = useRef(null);
  	const { t } = useTranslation();
  	const translate = t;
	const dispatch = useDispatch();
	const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;
	const navigate = useNavigate();

	const [marketoRestPreference, setMarketoRestPreference] = useState();
	const [eloquaPreference, setEloquaPreference] = useState();
	const [brightcovePreference, setBrightcovePreference] = useState();
	const [pardotPreference, setPardotPreference] = useState();
	const [vidyardPreference, setVidyardPreference] = useState();
	const [uberflipPreference, setUberflipPreference] = useState();
	const [exactTargetPreference, setExactTargetPreference] = useState();
	const [machineTranslationPreference, setMachineTranslationPreference] = useState();


	useEffect(() => {
		getCustBootstrapData();
		getPreference(Constants.ENABLE_MARKETOREST_INTEGRATION, setMarketoRestPreference);
		getPreference(Constants.ENABLE_ELOQUA_INTEGRATION, setEloquaPreference);
		getPreference(Constants.ENABLE_BRIGHTCOVE_INTEGRATION, setBrightcovePreference);
		getPreference(Constants.ENABLE_PARDOT_INTEGRATION, setPardotPreference);
		getPreference(Constants.ENABLE_VIDYARD_INTEGRATION, setVidyardPreference);
		getPreference(Constants.ENABLE_UBERFLIP_INTEGRATION, setUberflipPreference);
		getPreference(Constants.ENABLE_EXACTTARGET_INTEGRATION, setExactTargetPreference);
		getPreference(Constants.ENABLE_MACHINE_TRANSLATION, setMachineTranslationPreference);

	}, [])

	$(".settion-top").click((e) => {
		let $target = $(e.target);
		let $link = $target.closest(".settion-top").find("a");
		if ($link && $link.length === 1 && $target.attr('type') !== 'checkbox') {
			navigate($link.attr("href"))
		}
	});

	//get all features, preferences and other info of customer and store in redux for reuse.
	const getCustBootstrapData = () => {
		const dateTimestamp = dateConvertToTimeStamp();
		getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA)
		.then((res)=>{
			let bootstrapData = res.data?.data;			
			getAxiosResponse(APIUrls.CUSTOMER_ORG_PREFERENCE_ALL + `?_=${dateTimestamp}`
			).then(response => {
				Object.assign({}, bootstrapData, {"orgPreferences" : res.data?.data})
			}).catch(error => {
				handleError(error);
			})
			dispatch(updateCustomerBootstrapData(bootstrapData))
		}).catch(err => {
			handleError(err);
		})
	}

	const isCustomerAdminUser = () => {
	if (custBootstrapDataRedux?.roleSet?.value !== 'ROLE_CUSTOMER'){
    			return false;
	}
	return true;
	}
	

	const getPermissions = useSelector(
		(rolePermissionSelected) => rolePermissionSelected.role_permission,
	  ).value;

  	const getPreference = (preference, setValue) => {
		const dateTimestamp = dateConvertToTimeStamp();
		getAxiosResponse(
			APIUrls.CUSTOMER_ORG_PREFERENCE + `?preference=${preference}&_=${dateTimestamp}`
		).then(res => {
			if (res.data.code === 200) {
				const preference = transformBlankToNull(res.data.data);
				setValue(preference);
			}
		}).catch(err => {
			handleError(err);
		})
  	} 

	const updatePreference = (e, service) => {
		const dateTimestamp = dateConvertToTimeStamp();
		let preferenceString;
		let el = jQuery(e.target);
		let value = "" + el.is(':checked');
		let localPreference;

		switch(service) {
			case Constants.MARKETOREST:
				preferenceString = `?preference=${Constants.ENABLE_MARKETOREST_INTEGRATION}`;
				localPreference = JSON.parse(JSON.stringify(marketoRestPreference));
				localPreference.status = value;
				break;
			case Constants.ELOQUA:
				preferenceString = `?preference=${Constants.ENABLE_ELOQUA_INTEGRATION}`;
				localPreference = JSON.parse(JSON.stringify(eloquaPreference));
				localPreference.status = value;
				break;
			case Constants.BRIGHTCOVE:
				preferenceString = `?preference=${Constants.ENABLE_BRIGHTCOVE_INTEGRATION}`;
				localPreference = JSON.parse(JSON.stringify(brightcovePreference));
				localPreference.status = value;
				break;
			case Constants.PARDOT:
				preferenceString = `?preference=${Constants.ENABLE_PARDOT_INTEGRATION}`;
				localPreference = JSON.parse(JSON.stringify(pardotPreference));
				localPreference.status = value;
				break;
			case Constants.VIDYARD:
				preferenceString = `?preference=${Constants.ENABLE_VIDYARD_INTEGRATION}`;
				localPreference = JSON.parse(JSON.stringify(vidyardPreference));
				localPreference.status = value;
				break;
			case Constants.UBERFLIP:
				preferenceString = `?preference=${Constants.ENABLE_UBERFLIP_INTEGRATION}`;
				localPreference = JSON.parse(JSON.stringify(uberflipPreference));
				localPreference.status = value;
				break;
			case Constants.EXACTTARGET:
				preferenceString = `?preference=${Constants.ENABLE_EXACTTARGET_INTEGRATION}`;
				localPreference = JSON.parse(JSON.stringify(exactTargetPreference));
				localPreference.status = value;
				break;
			case Constants.MACHINE_TRANSLATION:
				if(machineTranslationPreference!==undefined){
					preferenceString = `?preference=${Constants.ENABLE_MACHINE_TRANSLATION}`;
					localPreference = JSON.parse(JSON.stringify(machineTranslationPreference));
					localPreference.status = value;
					break;
				}
				
			default:
				break;
		}
		getAxiosResponse(APIUrls.FULL_USER + `?_=${dateTimestamp}`
		).then(res => {
			let user = transformBlankToNull(res.data.data);
			changeUserPermission(user, value, service);
		})
		
		putAxiosResponse(
			APIUrls.CUSTOMER_ORG_PREFERENCE + preferenceString, localPreference
		).then(res => {
			if (res.data.code === 200) {
				switch(service) {
					case Constants.MARKETOREST:
						getPreference(Constants.ENABLE_MARKETOREST_INTEGRATION, setMarketoRestPreference);
						break;
					case Constants.ELOQUA:
						getPreference(Constants.ENABLE_ELOQUA_INTEGRATION, setEloquaPreference);
						break;
					case Constants.BRIGHTCOVE:
						getPreference(Constants.ENABLE_BRIGHTCOVE_INTEGRATION, setBrightcovePreference);
						break;
					case Constants.PARDOT:
						getPreference(Constants.ENABLE_PARDOT_INTEGRATION, setPardotPreference);
						break;
					case Constants.VIDYARD:
						getPreference(Constants.ENABLE_VIDYARD_INTEGRATION, setVidyardPreference);
						break;
					case Constants.UBERFLIP:
						getPreference(Constants.ENABLE_UBERFLIP_INTEGRATION, setUberflipPreference);
						break;
					case Constants.EXACTTARGET:
						getPreference(Constants.ENABLE_EXACTTARGET_INTEGRATION, setExactTargetPreference);
						break;
					case Constants.MACHINE_TRANSLATION:
						getPreference(Constants.ENABLE_MACHINE_TRANSLATION, setMachineTranslationPreference);
						break;
					default:
						break;
				}
			}
		}).catch(err => {
			handleError(err);
		})
	}

	const changeUserPermission = (user, isYes, service) => {
		let serviceType;
		if (service === Constants.MARKETOREST) {
		  user.permissions[Constants.MARKETOREST_ACCESS] = isYes;
		  serviceType = Constants.MARKETOREST
		} else if (service === Constants.ELOQUA) {
		  user.permissions[Constants.ELOQUA_ACCESS] = isYes;
		  serviceType = Constants.ELOQUA
		} else if (service === Constants.BRIGHTCOVE) {
		  user.permissions[Constants.BRIGHTCOVE_ACCESS] = isYes;
		  serviceType = Constants.BRIGHTCOVE
		} else if (service === Constants.PARDOT) {
		  user.permissions[Constants.PARDOT_ACCESS] = isYes;
		  serviceType = Constants.PARDOT
		} else if (service === Constants.VIDYARD) {
		  user.permissions[Constants.VIDYARD_ACCESS] = isYes;
		  serviceType = Constants.VIDYARD
		} else if (service === Constants.UBERFLIP) {
		  user.permissions[Constants.UBERFLIP_ACCESS] = isYes;
		  serviceType = Constants.UBERFLIP
		} else if (service === Constants.EXACTTARGET) {
		  user.permissions[Constants.EXACTTARGET_ACCESS] = isYes;
		  serviceType = Constants.EXACTTARGET
		} else if (service === Constants.MACHINE_TRANSLATION) {
			user.permissions[Constants.MACHINE_TRANSLATION] = isYes;
			serviceType = Constants.MACHINE_TRANSLATION
		  }
		postAxiosResponse(APIUrls.CUSTOMER_EXTERNAL_SERVICE_ACCESS_PERMISSION(user.userId, serviceType), user
		).then((res) => {
		}).catch((err) => {
			const errorMessage = "err - ";
			logError(errorMessage, err); 		})
	}
	const crumbs = [
		{label:'Settings', url:''},
	];
	
	useEffect(()=>{
		$(".lastdisable").trigger("focus");
	}, [])

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
	    <Header ref={scrollRef} />
        <LeftNavbar />
	  <section className="dashboard-content">
	   <div id="content" className="dashboard-wrap">
	    <Breadcrumb crumbs={ crumbs } />
         <div className="setting-section">
			<div className="white-bg">
              <h2>{translate("settings.settings")}</h2>
			  <div className="setting-content flex">
			  {getPermissions.includes('PROJECT_SETTINGS')? (
                <div className="setting-list">
                  <h3>{translate("settings.project_settings")}</h3>
				  <ul>
					<li>
						<div className="settion-top flex-center">
						  <strong>{translate("settings.intended_use")}</strong>
						  <div className="right flex-center">
						     <Link to="project-setting-intendend" aria-label="Intended Uses and Work Items">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						</div>
						<p>{translate("settings.categories_classify")}</p>
					 </li>
					 <li>
						<div className="settion-top flex-center">
						  <strong>{translate("settings.project_template")}</strong>
						  <div className="right flex-center">
						     <Link to="project-templates" aria-label="Project Templates">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						</div>
						<p>{translate("settings.project_template_description")}</p>
					 </li>
					 <li>
						 <div className="settion-top flex-center">
						   <strong>{translate("settings.language_available")}</strong>
						   <div className="right flex-center">
						     <Link to="project-setting-language" aria-label="Languages Available for Translation Projects">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						 </div>
						 <p>{translate("settings.target_source_language")}</p>
					 </li>
					 <li>
						 <div className="settion-top flex-center">
						   <strong> {translate("settings.language_presets")}</strong>
						   <div className="right flex-center">
						     <Link to="project-setting-language-presets" aria-label="Language Presets">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						 </div>
						 <p>{translate("settings.projects_campaigns")}</p>
					 </li>
					 <li>
						<div className="settion-top flex-center">
						  <strong>{translate("settings.custom_code_mapping")}</strong>
						  <div className="right flex-center">
						     <Link to="project-setting-language-custom-code-mapping" aria-label="Language Custom Code Mapping">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						</div>
						<p>{translate("settings.add_language_codes")}</p>
					</li>
					<li>
						<div className="settion-top flex-center">
						  <strong>{translate("settings.preferred_vendors")}</strong>
						  <div className="right flex-center">
						     <Link to="project-setting-preferred-vendor" aria-label="Preferred Vendors">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						</div>
						<p>{translate("settings.change_preffered_vendors")}</p>
				    </li>
					<li>
						<div className="settion-top flex-center">
						  <strong>{translate("settings.review_workflow_templates")}</strong>
						  <div className="right flex-center">
						     <Link to="/settings/review-workflow" aria-label="Review Workflow Templates">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						</div>
						<p>{translate("settings.20_templates")}</p>
					</li>
					<li>
						<div className="settion-top flex-center">
						  <strong>{translate("settings.project_tags")}</strong>
						  <div className="right flex-center">
						     <Link to="project-setting-project-tag" aria-label="Project Tags">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						</div>
						<p>{translate("settings.edit_project_tags")}</p>
					</li>
					<li>
						<div className="settion-top flex-center">
						  <strong>{translate("settings.fuzzy_matching_quotes")}</strong>
						  <div className="right flex-center">
						     <Link to="project-setting-fuzzy" aria-label="Fuzzy Matching in Vendor Quotes">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						</div>
						<p>{translate("settings.fuzzy_matching")}</p>
					 </li>
					 <li>
						 <div className="settion-top flex-center">
						   <strong>{translate("settings.one_review")}</strong>
						   <div className="right flex-center">
						     <Link to="project-setting-onereview" aria-label="One Review">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						 </div>
						 <p>{translate("settings.review_experience")}</p>
					 </li>
					 <li>
						 <div className="settion-top flex-center">
						   <strong>Error Topology</strong>
						   <div className="right flex-center">
						     <Link to="project-setting-error-topology" aria-label="Error Topology">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						 </div>
						 <p>{translate("settings.add_delete_enable")}</p>
					 </li>
				  </ul>
				  
				</div>
				):null}
				{getPermissions.includes('SYSTEM_SETTINGS')? (
				  <div className="setting-list">
					<h3>{translate("settings.system_settings")}</h3>
					<ul>
					{getPermissions.includes('COMPANY_INFORMATION')? (
					  <li>
						 <div className="settion-top flex-center">
						   <strong>{translate("settings.company_information")}</strong>
						   <div className="right flex-center">
						     <Link to="system-setting-company-information" aria-label="Company Information">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						 </div>
						 <p>{translate("settings.name_addres_financial_contact_information")}</p>
					  </li>
					) :null }
					{getPermissions.includes('COMPANY_DEPARTMENTS')? (
					  <li>
						  <div className="settion-top flex-center">
							<strong>{translate("settings.company_departments")}</strong>
							<div className="right flex-center">
						     <Link to="system-setting-company-department" aria-label="Company Departments">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						  </div>
						  <p>{translate("settings.segment_users_projects")}</p>
					  </li>
					  ) :null }
					  {getPermissions.includes('NDA')? (
					  <li>
						  <div className="settion-top flex-center">
							<strong>Non-Disclosure Agreement (NDA)</strong>
							<div className="right flex-center">
						     <Link to="system-setting-NDA" aria-label="Non-Disclosure Agreement (NDA)">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						  </div>
						  <p>{translate("settings.company_non-disclosure_agreement")}</p>
					  </li>
					  ) : null }
					  {getPermissions.includes('PURCHASE_ORDER')? (
					  <li>
						  <div className="settion-top flex-center">
							<strong>{translate("settings.purchase_orders")}</strong>
							<div className="right flex-center">
						     <Link to="purchase-order" aria-label="Purchase Orders">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						  </div>
						  <p>{translate("settings.manage_browse")}</p>
					  </li>
					) : null }
					</ul>
					
				  </div>
				):null}  
				  {getPermissions.includes('INTEGRATIONS')? (
				  <div className="setting-list">
					<h3>{translate("settings.integration_settings")}</h3>
					<ul>
					{(custBootstrapDataRedux?.features?.MARKETOREST_INTEGRATION !== undefined && custBootstrapDataRedux?.features?.MARKETOREST_INTEGRATION === true && (custBootstrapDataRedux?.permissions?.MARKETOREST_ACCESS || isCustomerAdminUser())) &&
                            <li>
						  <div className="settion-top flex-center">
							<strong>{translate("settings.marketo_rest_integration")}</strong>
							<div className="right flex-center">
						   <div className="form-switch">
						   {getPermissions.includes('TOGGLE_EDIT') ? (
						     <input type="checkbox" role="switch" aria-label="MarketoRest Integration Settings" className="switch" checked={marketoRestPreference?.status === 'true'}
							 onChange={(e) => updatePreference(e, Constants.MARKETOREST)} />
							 ) : null}
							</div>
						     <Link to="integration-setting-marketoRest-integration" aria-label="MarketoRest Integration Settings">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						  </div>
						  <p>{translate("settings.marketo_multilingual_emails")}</p>
					  </li>
					}
					{(custBootstrapDataRedux?.features?.ELOQUA_INTEGRATION !== undefined && custBootstrapDataRedux?.features?.ELOQUA_INTEGRATION === true && (custBootstrapDataRedux?.permissions?.ELOQUA_ACCESS || isCustomerAdminUser())) &&
						<li>
						<div className="settion-top flex-center">
						<strong>Eloqua Integration</strong>
						<div className="right flex-center">
						<div className="form-switch">
						{getPermissions.includes('TOGGLE_EDIT') ? (
						<input type="checkbox" role="switch" aria-label="Eloqua Integration Settings" className="switch" checked={eloquaPreference?.status === 'true'}
						onChange={(e) => updatePreference(e, Constants.ELOQUA)} />
						) : null}
						</div>
						<Link to="integration-setting-eloqua-integration" aria-label="Eloqua Integration Settings">
							<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
								<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</Link>
						</div>
						</div>
						<p>Browse, manage and send your Eloqua assets to translation.</p>
						</li>
					}
					{(custBootstrapDataRedux?.features?.BRIGHTCOVE_INTEGRATION !== undefined && custBootstrapDataRedux?.features?.BRIGHTCOVE_INTEGRATION === true && (custBootstrapDataRedux?.permissions?.BRIGHTCOVE_ACCESS || isCustomerAdminUser()) ) &&
						<li>
						<div className="settion-top flex-center">
						<strong>Brightcove Integration</strong>
						<div className="right flex-center">
						<div className="form-switch">
						{getPermissions.includes('TOGGLE_EDIT') ? (
						<input type="checkbox" role="switch" aria-label="Brightcove Integration Settings" className="switch" checked={brightcovePreference?.status === 'true'}
						onChange={(e) => updatePreference(e, Constants.BRIGHTCOVE)} />
						) : null}
						</div>
						<Link to="integration-setting-brightcove-integration" aria-label="Brightcove Integration Settings">
							<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
								<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</Link>
						</div>
						</div>
						<p>Increase Reach and Revenue with Video Marketing.</p>
					</li>
					}

					{(custBootstrapDataRedux?.features?.PARDOT_INTEGRATION !== undefined && custBootstrapDataRedux?.features?.PARDOT_INTEGRATION === true && (custBootstrapDataRedux?.permissions?.PARDOT_ACCESS || isCustomerAdminUser())) &&
						<li>
						<div className="settion-top flex-center">
						<strong>Pardot Integration</strong>
						<div className="right flex-center">
						<div className="form-switch">
						{getPermissions.includes('TOGGLE_EDIT') ? (	
						<input type="checkbox" role="switch" aria-label="Pardot Integration Settings" className="switch" checked={pardotPreference?.status === 'true'}
						onChange={(e) => updatePreference(e, Constants.PARDOT)} />
						) : null}
						</div>
						<Link to="integration-setting-pardot-integration" aria-label="Pardot Integration Settings">
							<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
								<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</Link>
						</div>
						</div>	
						<p>Browse and send your Pardot multilingual emails to translation.</p>
					</li>
					}
					{(custBootstrapDataRedux?.features?.VIDYARD_INTEGRATION !== undefined && custBootstrapDataRedux?.features?.VIDYARD_INTEGRATION === true && (custBootstrapDataRedux?.permissions?.VIDYARD_ACCESS || isCustomerAdminUser())) &&
						<li>
						  <div className="settion-top flex-center">
							<strong>Vidyard Integration</strong>
							<div className="right flex-center">
						   <div className="form-switch">
						   {getPermissions.includes('TOGGLE_EDIT') ? (
						     <input type="checkbox" role="switch" aria-label="Vidyard Integration Settings" className="switch" checked={vidyardPreference?.status === 'true'}
							 onChange={(e) => updatePreference(e, Constants.VIDYARD)} />
							 ) : null}
							</div>
						     <Link to="integration-setting-vidyard-integration" aria-label="Vidyard Integration Settings">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						  </div>
						  <p>Browse and send your Vidyard multilingual emails to translation.</p>
					  </li>
					}
					{(custBootstrapDataRedux?.features?.UBERFLIP_INTEGRATION !== undefined && custBootstrapDataRedux?.features?.UBERFLIP_INTEGRATION === true && (custBootstrapDataRedux?.permissions?.UBERFLIP_ACCESS || isCustomerAdminUser()) ) &&
						<li>
						  <div className="settion-top flex-center">
							<strong>Uberflip Integration</strong>
							<div className="right flex-center">
						   <div className="form-switch">
						   {getPermissions.includes('TOGGLE_EDIT') ? (
						     <input type="checkbox" role="switch" aria-label="Uberflip Integration Settings" className="switch" checked={uberflipPreference?.status === 'true'}
							 onChange={(e) => updatePreference(e, Constants.UBERFLIP)} />
							 ) : null}
							</div>
						     <Link to="integration-setting-uberflip-integration" aria-label="Uberflip Integration Settings">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						  </div>
						  <p>Browse and send your Uberflip multilingual emails to translation.</p>
					  </li>
					}
					{(custBootstrapDataRedux?.features?.EXACTTARGET_INTEGRATION !== undefined && custBootstrapDataRedux.features?.EXACTTARGET_INTEGRATION === true && (custBootstrapDataRedux?.permissions?.EXACTTARGET_ACCESS || isCustomerAdminUser()))  &&
						<li>
						  <div className="settion-top flex-center">
							<strong>ExactTarget Integration</strong>
							<div className="right flex-center">
						   <div className="form-switch">
						   {getPermissions.includes('TOGGLE_EDIT') ? (
						     <input type="checkbox" role="switch" aria-label="ExactTarget Integration Settings" className="switch" checked={exactTargetPreference?.status === 'true'}
							 onChange={(e) => updatePreference(e, Constants.EXACTTARGET)} />
							 ) : null}
							</div>
						     <Link to="integration-setting-exacttarget-integration" aria-label="ExactTarget Integration Settings">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>
						   </div>
						  </div>
						  <p>Browse and send your ExactTarget multilingual emails to translation.</p>
					  </li>
					}
					{(custBootstrapDataRedux?.features?.MACHINE_TRANSLATION !== undefined && custBootstrapDataRedux?.features?.MACHINE_TRANSLATION === true && (custBootstrapDataRedux?.permissions?.MACHINE_TRANSLATION_ACCESS || isCustomerAdminUser())) &&
						<li>
						  <div className="settion-top flex-center">
							<strong>Machine Translation</strong>
							<div className="right flex-center">
						   <div className="form-switch">
						   {getPermissions.includes('TOGGLE_EDIT') ? (
						   <input type="checkbox" role="switch" aria-label="Machine Translation Integration Settings" className="switch" checked={machineTranslationPreference?.status === 'true'}
							 onChange={(e) => updatePreference(e, Constants.MACHINE_TRANSLATION)} />
							 ) : null}
							</div>
							<Link to="integration-setting-machine-translation-integration" aria-label="Machine Translation Integration Settings">
								<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
									<path d="M1.27734 9L5.27734 5L1.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
						     </Link>

						     
						   </div>
						  </div>
						  <p>Instantly translate your content using a machine translation engine.</p>
					  </li>
					}
					</ul>
					
				  </div>
				  ) : null }
			  </div>
			</div>
		 </div>

	  </div>
	</section>
    </div>

</div>
  )
}
